import {autorun, observable, runInAction, Socket, io} from '@api'
import {configs, globalStores as stores, ui} from '@stores'
import {synchronizeStores} from '@stores/SynchronizeStores'
import {authStore, guid} from '@utils'
import {computed} from 'mobx'

export class SocketIOStore {
  @observable clientId = guid()

  constructor() {
    synchronizeStores(() => {
      autorun(() => {
        const {accessToken, userIsAuthenticated} = authStore,
          {deployments, userSettings} = stores

        if (deployments.deploymentConfig?.settings?.socketIO === false) return

        const { socketIoUrl, clientId} = this

        if (!socketIoUrl) return

        if (!userIsAuthenticated) {
          if (this.client) {
            this.client.disconnect()
            this.client = null
          }
        } else {
          runInAction(() => {
            if (this.client) {
              this.client.disconnect()
            }

            const socket = this.client = io(socketIoUrl, {auth: {token: accessToken}, extraHeaders: { 'x-webclient-id': clientId, authorization: accessToken }, path: userSettings?.dev?.localNest ? null : '/design-board-nest/socket.io' }),
              {users: {user: {id: userId}}} = stores

            socket.on('connect', () => {
              console.log('Websocket Connected')
              socket.emit('registerClient', {
                userId
              })
            })

            socket.on('create_catalog_item', (v) => {

            })

            socket.on('update_catalog_item', (v) => {
              console.log(`update_catalog_item`, v)
            })
          })
        }
      })
    })

    //     const {config: {graphqlEndpoint, servicesUrl}} = configs, {accessToken} = authStore
    //
    //     runInAction(() => {
    //       this.nestClient = axios.create({
    //         //baseURL: `${servicesEndpoint.substring(0, servicesEndpoint.lastIndexOf('/'))}/`
    //         baseURL: `http://localhost:3000`
    //       })
    //       this.nestClient.defaults.headers.common['Authorization'] = accessToken
    //     })
    //   }, {name: `Create axios instance and set auth header`})
    // })
  }

  @computed get socketIoUrl() {
    const {config: {config: {url}}, userSettings: {dev}} = stores

    return DEBUG && dev?.localNest ? 'ws://localhost:5959' : (url ?? window.location.origin)
  }

  @observable.ref client: Socket
}

export const socketIO = new SocketIOStore()

export type SOCKET_IO_EVENTS = 'pdfJobUpdated'


// WEBPACK FOOTER //
// ./src/stores/socketIO/SocketIOStore.ts